import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { arrayTreeFilter } from '@arco-design/mobile-utils';
import MultiPicker from './multi-picker';
import PickerCell from './picker-cell';
var Cascader = /*#__PURE__*/forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
      itemStyle = props.itemStyle,
      cols = props.cols,
      data = props.data,
      disabled = props.disabled,
      clickable = props.clickable,
      itemHeight = props.itemHeight,
      wrapperHeight = props.wrapperHeight,
      rows = props.rows,
      hideEmptyCols = props.hideEmptyCols,
      onPickerChange = props.onPickerChange,
      onValueChange = props.onValueChange,
      _props$selectedValue = props.selectedValue,
      selectedValue = _props$selectedValue === void 0 ? [] : _props$selectedValue,
      touchToStop = props.touchToStop;
  var pickerCellsRef = useRef([]);
  useImperativeHandle(ref, function () {
    return {
      getCellMovingStatus: getCellMovingStatus,
      scrollToCurrentIndex: scrollToCurrentIndex
    };
  });

  function getCellMovingStatus() {
    return pickerCellsRef.current.map(function (cell) {
      return cell.movingStatus;
    });
  }

  function scrollToCurrentIndex() {
    pickerCellsRef.current.forEach(function (cell) {
      return cell.scrollToCurrentIndex();
    });
  }

  function _onValueChange(value, index) {
    var children = arrayTreeFilter(data, function (item, level) {
      return level <= index && item.value === value[level];
    });
    var child = children[index];
    var i;

    for (i = index + 1; i < cols && child && child.children; i++) {
      child = child.children[0];
      value[i] = child.value;
    }

    value.length = i;
    onValueChange == null ? void 0 : onValueChange(value, index);
  }

  function _formatData() {
    var childrenTree = arrayTreeFilter(data, function (item, level) {
      return item.value === selectedValue[level];
    }).map(function (item) {
      return item.children;
    });
    var needPad = cols - childrenTree.length;

    if (needPad > 0) {
      for (var i = 0; i < needPad; i++) {
        childrenTree.push([]);
      }
    }

    childrenTree.length = cols - 1;
    childrenTree.unshift(data);
    return childrenTree;
  }

  var formatData = useMemo(function () {
    return _formatData();
  }, [data, selectedValue]);
  return /*#__PURE__*/React.createElement(MultiPicker, {
    prefixCls: prefixCls + "-picker",
    data: formatData,
    selectedValue: selectedValue,
    itemHeight: itemHeight,
    onValueChange: _onValueChange,
    onPickerChange: onPickerChange
  }, formatData.map(function (item, index) {
    return /*#__PURE__*/React.createElement(PickerCell, {
      key: index + "_picker_cell_cascader",
      data: item || [],
      style: itemStyle,
      prefixCls: prefixCls + "-picker",
      clickable: clickable,
      itemHeight: itemHeight,
      wrapperHeight: wrapperHeight,
      disabled: disabled,
      rows: rows,
      hideEmptyCols: hideEmptyCols,
      ref: function ref(cellRef) {
        return cellRef && (pickerCellsRef.current[index] = cellRef);
      },
      touchToStop: touchToStop
    });
  }));
});
export default Cascader;